import React, { useEffect, useState } from "react";
import { ActionIcon, Badge, Modal, Table, Text } from "@mantine/core";
import { Eye, History, Plus } from "tabler-icons-react";
import { getRelatedAgreement } from "../../utilities/apis/agreements";
import { formatDate } from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { getStatusColor, getStatusText } from "../../utilities/enums";
import AgreementAuditLogModal from "./AgreementAuditLogModal";
import { Tooltip } from "@mantine/core";

const RelatedAgreementModal = ({ agreementId }) => {
  const [relatedAgreementData, setRelatedAgreementData] = useState({
    agreements: null,
    loading: true,
    count: 0,
  });
  const [showModalRelated, setShowModalRelated] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [relatedId, setRelatedId] = useState(null);
  const [showAuditId, setShowAuditId] = useState(null);

  const onViewClick = (agreementviewId) => {
    const url = `/app/agreements_manager/agreements/details/${agreementviewId}`;
    window.open(url, "_blank");
  };
  useEffect(() => {
    const fetchRelatedAgreement = async () => {
      try {
        const response = await apiWrapWithErrorWithData(
          getRelatedAgreement({ agreementId }),
        );
        console.log("Related Agreement Response:", response);
        if (response.success) {
          setRelatedAgreementData({
            loading: false,
            count: response.count,
            agreements: response.dataArray,
          });
        }
      } catch (error) {
        console.error("Error fetching audit log:", error);
      }
    };

    fetchRelatedAgreement();
  }, [agreementId]);

  return (
    <>
      <div
        className="flex items-center justify-between mb-5 pb-3"
        style={{
          borderBottom: "1px solid #e9ecef",
        }}
      >
        <div>
          <Text fw={600} size="lg">
            Related Agreements
          </Text>

          <Text c="dimmed" size="sm">
            Agreement #{agreementId}
          </Text>
        </div>

        <Badge variant="light" size="lg">
          {relatedAgreementData.count || 0}
        </Badge>
      </div>

      {!relatedAgreementData.loading &&
        relatedAgreementData.agreements?.length === 0 && (
          <Text c="dimmed" ta="center" py="xl">
            No related agreements found.
          </Text>
        )}
      {!relatedAgreementData?.loading && (
        <div
          className="flex flex-col"
          style={{
            overflowX: "scroll",
            marginTop: "10px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <Table
            striped
            highlightOnHover
            verticalSpacing="md"
            horizontalSpacing="md"
            withBorder
            withColumnBorders
            style={{
              tableLayout: "fixed",
            }}
          >
            <thead>
              <tr>
                <th>AIN</th>
                <th>Type</th>
                <th>Business Unit</th>
                <th>Status</th>
                <th>Second Party</th>
                <th>Contract Date</th>
                <th style={{ width: "120px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {relatedAgreementData.agreements.map((row) => (
                <tr key={row.id}>
                  <td>{`agreement-${row.id}`}</td>
                  <td>{row.typeOfAgreement}</td>
                  <td>{row.mapBusinessunit}</td>

                  <td>
                    <Badge color={getStatusColor(row.status)}>
                      {getStatusText(row.status)}
                    </Badge>
                  </td>

                  <td>{row.secondParty?.name || "-"}</td>
                  <td>{formatDate(row.dateOfContract)}</td>

                  <td style={{ width: 120 }}>
                    <div className="flex items-center gap-2">
                      <Tooltip label="View Agreement">
                        <ActionIcon
                          variant="light"
                          color="blue"
                          onClick={() => onViewClick(row.id)}
                        >
                          <Eye size={16} />
                        </ActionIcon>
                      </Tooltip>

                      {row.relationshipWith && (
                        <Tooltip label="Related Agreements">
                          <ActionIcon
                            variant="light"
                            color="teal"
                            onClick={() => {
                              setRelatedId(row.id);
                              setShowModalRelated(true);
                            }}
                          >
                            <Plus size={16} />
                          </ActionIcon>
                        </Tooltip>
                      )}

                      <Tooltip label="History">
                        <ActionIcon
                          variant="light"
                          color="orange"
                          onClick={() => {
                            setShowAuditId(row.id);
                            setShowModal(true);
                          }}
                        >
                          <History size={16} />
                        </ActionIcon>
                      </Tooltip>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      {showModalRelated && (
        <Modal
          opened={showModalRelated}
          onClose={() => {
            setShowModalRelated(false);
            setRelatedId(null);
          }}
          size="90%"
          centered
          withinPortal
          styles={{
            body: {
              overflowX: "auto",
            },
          }}
        >
          <RelatedAgreementModal agreementId={relatedId} />
        </Modal>
      )}
      {showModal && (
        <Modal
          overflow="inside"
          opened
          onClose={() => setShowModal(false)} // Call the handler on modal close
          size="calc(80vw)"
        >
          <AgreementAuditLogModal agreementId={showAuditId} />
        </Modal>
      )}
    </>
  );
};

export default RelatedAgreementModal;
